/**
 * Video Element
 */

import type { ElementDefinition } from '@ai-content-hub/content-kit';
import { videoElementSchema, type VideoElementData } from './schema';
import { VideoEdit } from './VideoEdit';
import { VideoPlayer } from './VideoPlayer';

export { videoElementSchema, type VideoElementData };
export { VideoEdit };
export { VideoPlayer };

export const videoElement: ElementDefinition<VideoElementData, void> = {
    schema: videoElementSchema,
    EditComponent: VideoEdit as any,
    PlayerComponent: VideoPlayer as any,
};
